import { render, staticRenderFns } from "./AddPanel.vue?vue&type=template&id=67418d54&scoped=true&"
import script from "./AddPanel.vue?vue&type=script&lang=js&"
export * from "./AddPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddPanel.vue?vue&type=style&index=0&id=67418d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67418d54",
  null
  
)

export default component.exports